var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFiltrar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4664 1.36927C16.4755 1.23127 16.427 1.09568 16.3326 0.994664C16.2381 0.893646 16.1061 0.836195 15.9678 0.835938H1.99978C1.86142 0.835999 1.72927 0.893389 1.63478 0.994453C1.54028 1.09552 1.49189 1.23122 1.50111 1.36927C1.74207 4.72445 4.18673 7.50916 7.48245 8.1826V14.7659C7.48252 14.9599 7.59475 15.1363 7.7704 15.2186C7.94605 15.3008 8.15342 15.2741 8.30245 15.1499L10.3024 13.4833C10.4166 13.3884 10.4826 13.2477 10.4824 13.0993V8.1826C13.7793 7.51041 16.2254 4.72534 16.4664 1.36927Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFiltrar);
export default __webpack_public_path__ + "static/media/iconFiltrar.4f10c72490911ba5a28fdee3ad7aba65.svg";
export { ForwardRef as ReactComponent };